import { useMemo } from 'react'

import { Post } from 'types/post'
import { Program } from 'types/program'

import { useGroups } from './useGroups'

export const useGroupsForPost = (post: Post | undefined) => {
  const groupIds = useMemo(
    () =>
      post?.program?.id ? [post?.program?.id, ...(post?.programIds ?? [])] : post?.programIds ?? [],
    [post?.program?.id, post?.programIds],
  )

  const { data: groups, isLoading } = useGroups(groupIds.length > 0 ? groupIds : [])
  const postGroups: Array<Program> = useMemo(
    () => groups?.filter((p): p is Program => p != null) ?? [],
    [groups],
  )

  return { postGroups, isLoading }
}
